module.exports = __webpack_public_path__ + "fonts/HalisR-Black.f6e00f95.otf";